import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import CompletedIcon from '@/assets/icons/step-completed.svg?react';
import PendingIcon from '@/assets/icons/steps-pending.svg?react';
import { Status } from '@/types/steps';

interface Props {
  readonly status: Status | undefined;
}

export const VerifyModalStatusIndicatorItem: React.FC<React.PropsWithChildren<Props>> = (
  props: React.PropsWithChildren<Props>,
): React.ReactElement => {
  const { children: title, status } = props;

  return (
    <Box display="flex" alignItems="center" gap={1.5}>
      {/* The border is here because this way it looks exactly like the design does */}
      <Box width={20} height={20} flexShrink={0} border="1px solid transparent">
        {status === Status.completed ? (
          <CompletedIcon fill="currentColor" />
        ) : (
          <PendingIcon stroke="currentColor" />
        )}
      </Box>
      <Typography fontSize={16} fontWeight={400} color="custom.LightGray">
        {title}
      </Typography>
    </Box>
  );
};
